/**
 * Firebase composition root for the SSUP portal.
 *
 * Mirrors the consumer frontend's adapter, but points the shared
 * `@storyworm/firebase` implementation at the separate `storyworm-ssup`
 * project. Analytics is explicitly disabled: the portal must not emit into any
 * consumer Analytics property (partner/B2B activity is out of scope for
 * consumer/children metrics). Initializes eagerly on import so `auth`/`db` are
 * ready for the app shell.
 */
import { initFirebase, FirebaseService } from "@storyworm/firebase";
import { SSUP_FIREBASE_CONFIG } from "../resources/env";

const { auth, db } = initFirebase(SSUP_FIREBASE_CONFIG, { analytics: false });

export { auth, db, FirebaseService };
